<template>
  <div>
    <dataset v-slot="{ ds }" :ds-data="category_list" :ds-filter-fields="{
      title: startsWithFilter,
    }" :ds-search-in="['title']" :ds-search-as="{}" showEntries="6">
      <div class="row mb-2" :data-page-count="ds.dsPagecount">
        <div class="col-xl-7 col-md-6">
          <b-input-group class="input-group-search " :class="search_input_class">
            <template #prepend>
              <font-awesome-icon icon="fa-solid fa-magnifying-glass" size="lg" />
            </template>
            <dataset-search ds-search-placeholder="Search" :class="input_class" /></b-input-group>
        </div>
        <div class="col-xl-5 col-md-6 px-md-0 px-3 addButtonContainerDiv">
          <b-button :variant="btn_variant_primary" id="" class="btn-bumblebee btn-filter m-0 "
            :class="project_btn_class + ' ' + btn_size_class" @click="clickAddCategory">
            + Add New Category
          </b-button>
          <SaveCategory category="video_library" type="video" :client_name="client_name"
            :title="save_category_modal_title" :action_type="save_category_action_type"
            :category_id="selected_category_id" :category_title="selected_category_title"
            :category_description="selected_category_description" :modal_class="modal_class"
            :btn_submit_class="btn_submit_class" :form_label_class="form_label_class" :input_class="input_class"
            :btn_variant_primary="btn_variant_primary" :swal_confirm_button_class="swal_confirm_button_class"
            :swal_container_class="swal_container_class" :project_btn_class="project_btn_class" />
          <!-- </div>
                  <div class="col-xl-2 col-md-3 pl-0 addButtonContainerDiv"> -->
          <b-button :variant='btn_variant_info' id="" class="btn btn-filter m-0 "
            :class="project_btn_class + ' ' + btn_size_class" v-b-modal.saveVideoModal>
            + Add New Video
          </b-button>
          <save-video :client_name="client_name" type="video_library" sub_type="video" action_type="add"
            :category_list="category_list_select" :modal_class="modal_class"
            :error_validation_msg_class="error_validation_msg_class"
            :video_preview_container_class="video_preview_container_class"
            :add_video_btn_outline_variant="add_video_btn_outline_variant" :btn_submit_class="btn_submit_class"
            :progress_bar_class="progress_bar_class" :form_label_class="form_label_class" :input_class="input_class"
            :btn_variant_primary="btn_variant_primary" :vselect_class="vselect_class"
            :swal_confirm_button_class="swal_confirm_button_class" :swal_container_class="swal_container_class"
            :project_btn_class="project_btn_class" />
        </div>
      </div>
      <dataset-show class="d-none" :ds-show-entries="6" />

      <div class="row">
        <div class="col-md-12">
          <dataset-item class="row mb-3">
            <template #default="{ row }">
              <div class="col-xl-3 col-md-4">
                <router-link v-if="row.library_media != null &&
                  row.library_media.length > 0
                  " :to="category_tracks_url + row.id" class="card-link eventLink">

                  <MediaGallery :title="row.title" :videos="row.library_media" :media_gallery_class="media_gallery_class"
                    :media_card_class="media_card_class" />
                </router-link>
                <NoMedia v-else :title="row.title" message="No videos found" :media_gallery_class="media_gallery_class"
                  :card_no_found_media_class="card_no_found_media_class"
                  :no_found_media_text_class="no_found_media_text_class" />

                <b-row><b-col>
                    <b-button-group class="
                                  d-block
                                  text-center
                                " :class="btn_group_actions_class">
                      <b-button :variant="btn_variant_primary" size="sm" @click="clickEditCategory(
                        row.id,
                        row.title,
                        row.description
                      )
                        " :class="'btn-bumblebee ' + project_btn_class">Edit</b-button>
                      <b-button :variant='btn_variant_delete' size="sm" :class="'btn-bumblebee ' + project_btn_class"
                        @click="clickDeleteCategory(row.id)">Delete</b-button></b-button-group></b-col></b-row>
              </div>
            </template>
            <template #noDataFound>
              <div class="col-md-12 pt-2">
                <p class="text-center datasetNoFoundP " :class="dataset_not_found_data_class">
                  No data found
                </p>
              </div>
            </template>
          </dataset-item>
        </div>
      </div>
      <div class="
                    d-flex
                    flex-md-row flex-column
                    justify-content-between
                    align-items-center
                  ">
        <dataset-info class="mb-2 mb-md-0 datasetInfo " :class="dataset_data_info_class" />
        <dataset-pager :class="dataset_pagination_class" />
      </div>
    </dataset>
    <!-- delete modal -->
    <DeleteCategory :client_name="client_name" :category_id="selected_category_id" :media_type="media_library"
      sub_media_type="video" :btn_variant_primary="btn_variant_primary" :modal_class="modal_class"
      :confirm_message_class="confirm_message_class" :btn_submit_class="btn_submit_class"
      :btn_danger_outline_class="btn_danger_outline_class" :swal_confirm_button_class="swal_confirm_button_class"
      :swal_container_class="swal_container_class" :project_btn_class="project_btn_class" />
    <!-- end delete modal-->
  </div>
</template>

<script>
import axios from "axios";
import $ from "jquery";
import MediaGallery from "../media/MediaGallery.vue";
import SaveCategory from "../media/SaveCategory.vue";
import DeleteCategory from "../media/DeleteCategory.vue";
import SaveVideo from "../media/SaveVideo.vue";
import NoMedia from "../media/NoMediaCard.vue";

import {
  filterList,
  clone,
  isoDateToEuroDate,
  searchAsEuroDate,
} from "vue-dataset/docs/.vuepress/utilities";
import { debounce } from "vue-dataset/src/helpers";

export default {
  name: "MediaLibraryCategoryList",
  components: {
    MediaGallery,
    SaveCategory,
    DeleteCategory,
    SaveVideo,
    NoMedia,
  },
  props: ['client_name', 'media_library',
    'search_input_class', 'input_class', 'btn_size_class',
    'btn_variant_primary', 'btn_variant_info', 'btn_variant_delete', 'category_tracks_url',
    'btn_group_actions_class', 'dataset_not_found_data_class',
    'dataset_data_info_class', 'dataset_pagination_class',
    "modal_class", "confirm_message_class", "btn_submit_class",
    "btn_danger_outline_class",
    "form_label_class", "error_validation_msg_class", "video_preview_container_class",
    "add_video_btn_outline_variant", "progress_bar_class",
    "vselect_class",
    "media_gallery_class", "card_no_found_media_class", "no_found_media_text_class",
    "media_card_class", "swal_confirm_button_class", "swal_container_class", "project_btn_class"
  ],
  data() {
    return {
      category_list: [],
      category_list_select: [],
      onlineFilter: "",
      selected: 6,
      startsWith: "",
      // media_library: "video_library",
      save_category_modal_title: "Add New Category",
      selected_category_id: null,
      selected_category_title: null,
      selected_category_description: null,
      save_category_action_type: "add",
    };
  },
  mounted() {
    this.getMediaCategoryList();
  },
  computed: {},
  created() {
    this.startWithInput = debounce((e) => {
      this.startsWith = e.target.value;
    }, 100);
  },
  methods: {
    filterList,
    isoDateToEuroDate,
    searchAsEuroDate,
    updateData() {
      const updatedList = clone(category_list).slice(5, 5);
      this.category_list = updatedList;
    },
    startsWithFilter(value) {
      return value.toLowerCase().startsWith(this.startsWith.toLowerCase());
    },
    getMediaCategoryList() {
      console.log("in get categories");
      // this.category_list = [];
      let formData = new FormData();
      formData.append("media_library", this.media_library);
      axios
        .post("media/library/categories", formData, {
          headers: {
            Accept: "application/json",
            "Content-Type": "application/json",
            client: this.client_name,
            Authorization:
              "Bearer " +
              JSON.parse(window.localStorage.getItem("user")).access_token,
          },
        })
        .then((response) => {
          console.log(response);
          this.category_list = response.data;
          this.category_list_select = response.data.slice(0);

          this.category_list_select.push({ title: "New category", id: "new" });
        });
    },
    clickAddCategory() {
      console.log("in click add category");
      this.save_category_modal_title = "Add New Category";
      this.save_category_action_type = "add";
      this.selected_category_id = null;
      this.selected_category_title = null;
      this.selected_category_description = null;
      this.$root.$emit("bv::show::modal", "saveCategoryModal");
    },
    clickEditCategory(id, title, description) {
      console.log("in click edit category");
      console.log(id, title, description);
      this.save_category_modal_title = "Category Info";
      this.save_category_action_type = "edit";
      this.selected_category_id = id;
      this.selected_category_title = title;
      if (description == null || description == "null") {
        this.selected_category_description = null;
      } else {
        this.selected_category_description = description;
      }
      this.$root.$emit("bv::show::modal", "saveCategoryModal");
      // $('#saveCategoryModal').modal('show')
    },
    clickDeleteCategory(id) {
      console.log("click delete category", id);
      this.selected_category_id = id;

      this.$root.$emit("bv::show::modal", "deleteCategoryModal");
    },
  },
};
</script>



// WEBPACK FOOTER //
// src/components/media_components/library/CategoryList.vue